import {
  IError,
  IProfileConsentManagement,
  IQueryHookOptions,
} from '@comptia-sso/core';
import { UseMutateAsyncFunction, useMutation } from 'react-query';

// Services.
import { resendConsent } from 'services';

type ResendConsentFunction = UseMutateAsyncFunction<
  IProfileConsentManagement,
  IError
>;

type UseResendConsent = [ResendConsentFunction, IQueryHookOptions];

export const useResendConsent = (profileId = ''): UseResendConsent => {
  const { error, isError, isLoading, mutateAsync } = useMutation<
    IProfileConsentManagement,
    IError
  >(() => resendConsent(profileId));

  return [mutateAsync, { error, isError, isLoading }];
};
